import { useUser } from "../../context/UserContext";
import { Navigate } from "react-router-dom";
import LoadingComponent from "../loading/LoadingComponent"

const ProtectedRoute = ({ element, requiredPermissions }) => {
    const { user, loading } = useUser();

    if (loading) {
        return <LoadingComponent />; // Mostrar un spinner mientras carga el usuario
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredPermissions && !requiredPermissions.every(perm => user.authorities.includes(perm))) {
        return <Navigate to="/unauthorized" replace />;
    }

    return element; // Renderiza el componente si el usuario está autenticado y tiene permisos
};

export default ProtectedRoute;
